<template>
    <div class="w-full max-w-[24rem] md:max-w-[29rem] mx-auto">
        <div class="flex justify-center">
            <InputTypes
                v-model:value="no"
                type="text"
                :maxlength="10"
                label="要保人身分證號碼"
                :errorMsg="noErrorMsg"
                placeholder="請輸入身分證號碼"
                @validateValue="validateId"
            />
            <div
                class="mr-2.5"
                @click="iconMessage"
            >
                <SvgIcon
                    icon-name="warning"
                    class="w-10 h-10"
                />
            </div>
        </div>
        <div class="flex justify-center">
            <InputTypes
                label="驗證碼"
                :errorMsg="errors.verifyCode"
            >
                <template #input>
                    <InputIdentify
                        v-model:value="verifyCode"
                        v-model:reFresh="reFresh"
                        @validateValue="getIsPassverifyCode"
                    />
                </template>
            </InputTypes>
        </div>
        <div class="flex justify-center pt-2">
            <button
                class="btn w-full rounded-full gradient-primary border-0 max-w-[8.75rem]"
                @click.prevent="postApi"
            >
                確定
            </button>
        </div>
    </div>
</template>

<script>
import { reactive, ref, toRefs, inject } from 'vue';
import InputTypes from '@/components/inputs/InputTypes.vue';
import { localAndForeignID } from '@/utils/rules/customRules';
import InputIdentify from '@/components/inputs/InputIdentify.vue';

export default {
    components: {
        InputIdentify,
        InputTypes,
    },
    props: {
        id: {
            type: String,
            default: '',
        },
        bd: {
            type: String,
            default: '',
        },
    },
    emits: ['update:bd', 'update:id', 'postApi', 'update:verifyCode'],
    setup(props, { emit }) {
        const $vfm = inject('$vfm');
        const users = reactive({
            no: props.id,
            noErrorMsg: '',
            birthday: props.bd,
            verifyCode: '',
            birthdayErrorMsg: '',
            errors: {
                verifyCode: '',
            },
            reFresh: false,
        });
        const visiblePopup = ref(false);
        const isPassVerified = ref(false);
        const getIsPassverifyCode = (isPass) => {
            isPassVerified.value = isPass;
            users.errors.verifyCode = '';
        };

        const validateId = (id) => {
            const {
                message,
                val,
            } = localAndForeignID({
                value: id,
                errorMessage: '',
                isMustHave: true,
            });
            users.no = val;
            users.noErrorMsg = message;
            emit('update:id', val);
        };

        const postApi = () => {
            let canPost = false;
            validateId(users.no);
            validateVerifyCode(users.verifyCode);
            if (!users.noErrorMsg && !users.errors.verifyCode && users.no && users.verifyCode) {
                canPost = true;
            }
            emit('update:verifyCode', users.verifyCode);
            emit('postApi', canPost);
        };

        const iconMessage = () => {
            $vfm.show({
                component: 'DialogBase',
                params: {
                    title: '身分證號碼規則',
                    content: '*本國人士：請輸入身分證號碼(英文字母請以大寫輸入)<br/>*外籍人士：請輸入統一證號或居留證號<br/>*外籍人士保單號碼為@開頭，男性請輸入 @1+西元出生年月日，女性請輸入@2+西元出生年月日(例如:女性外籍人士西元出生年月日為2000年10月10日，請輸入@220001010)',
                    confirmButton: '確認',
                    cancelButton: null,
                },
                on: {
                    confirm() {
                        $vfm.hide('DialogBase');
                    },
                },
            });
        };
        const validateVerifyCode = (value) => {
            if (value === '') {
                users.errors.verifyCode = '請輸入驗證碼';
            } else if (!isPassVerified.value) {
                users.errors.verifyCode = '請輸入正確的驗證碼';
            }
        };
        return {
            ...toRefs(users),
            validateId,
            iconMessage,
            getIsPassverifyCode,
            visiblePopup,
            postApi,
            validateVerifyCode
        };
    },
};
</script>
